<template>

  <transition name="fade">

    <div class="image-blob" v-if="blobUrl">

      <img ref="image" :src="blobUrl"/>

    </div>

  </transition>

</template>

<script>
import http from "@/services/config/http-common";

export default {
  name: 't-image-blob',
  data() {
    return {
      localSrc: "",
      blobUrl: null,
    }
  },
  props: {
    showLoading: Boolean,
    blob:null,
    src: {
      type: String,
    },
  },
  methods: {

    async load() {

      return http.image(this.localSrc).then(blob => {
        this.blobUrl = blob
      })
    }

  },
  async mounted() {

    //Carregamento poderá ser interno ou externo

    this.localSrc = this.src

    if(this.localSrc && this.localSrc !== ''){
      await this.load()
    }else if(this.blob && this.blob !== ""){
      this.blobUrl = this.blob
    }


  },
  watch: {

    src(){
      this.load()
    },

    blob(){
      this.blobUrl = this.blob
    }

    /*src: {
      immediate: true,
      handler(src) {
        if (!src) return

        load(src).then(blob => {
          this.blobUrl = URL.createObjectURL(blob)
        })
      },
    },*/
  },
}
</script>

<style scoped>
</style>